import { useEffect, useRef, useState } from 'react';
import { useOneCartContext } from './OneCartContext';
import useExpiryTime, { getTimeLeft } from './useExpiryTime';

const useIsCartExpired = () => {
    const [isCartExpired, setCartExpiry] = useState(false);
    const observer = useRef(false);
    const { data: OneCartData, isFetching } = useOneCartContext();
    const { timeLeft, timerStarted } = useExpiryTime(OneCartData?.cart?.expiry);

    useEffect(() => {
        if (OneCartData?.cart?.expiry) {
            const timeLeftInMs = getTimeLeft(OneCartData?.cart?.expiry);
            const isCartItemPresent = OneCartData?.cart?.itemList.length;
            const isClubItemPresent = OneCartData?.cart?.itemList.some(item => item.origin === 'club');
            if (isCartItemPresent && isClubItemPresent && timeLeftInMs < 0) {
                setCartExpiry(true);
                observer.current = true;
            }
        }
    }, [OneCartData?.cart?.expiry, OneCartData?.cart?.itemList]);

    useEffect(() => {
        if (OneCartData?.cart?.expiry && timerStarted && timeLeft && timeLeft <= 0 && observer.current) {
            setCartExpiry(true);
        }
        if (OneCartData?.cart?.expiry && timeLeft && timeLeft > 0) {
            setCartExpiry(false);
            observer.current = true;
        }
    }, [OneCartData?.cart?.expiry, timeLeft, isFetching, timerStarted]);

    return isCartExpired;
};

export default useIsCartExpired;
